export let auth0Client = null;

export const setAuth0Client = (client) => {
  auth0Client = client;
}